module.exports = __webpack_public_path__ + "static/img/jjc_honor1.619dae69.png";